import api from "../../services/api";


export default async function getMessageDin() {
	
	const { data } = await  api.get(`/MensajesC`);
	return  data;
}

